<template>
    <v-dialog v-model="isVisible"
            no-click-animation
            autofocus
            max-width="50%">
    <v-card>
      <v-card-text>
        <v-layout xs12 v-if="item.category === 0 || item.category === 3">
          <v-flex>
            <v-btn class="primary" dark text  @click="optionEvent(0)">機車原融申請表-列印</v-btn>
          </v-flex>
        </v-layout>
        <br>
        <v-layout xs12 v-if="item.category === 1">
          <v-flex>
            <v-btn class="primary" dark text  @click="optionEvent(1)">購車分期申表-列印</v-btn>
          </v-flex>
        </v-layout>
        <br>
        <v-layout xs12 v-if="item.category === 0 || item.category === 3">
          <v-flex>
            <v-btn class="primary" dark text  @click="optionEvent(2)">機車原融申請表-套印</v-btn>
          </v-flex>
        </v-layout>
        <br>
        <v-layout xs12 v-if="item.category === 0 || item.category === 3">
          <v-flex>
            <v-btn class="primary" dark text  @click="optionEvent(9)">機車原融申請表-轉和潤申請書編輯</v-btn>
          </v-flex>
        </v-layout>
        <br>
        <v-layout xs12 v-if="item.category === 0 || item.category === 3">
          <v-flex>
            <v-btn class="primary" dark text  @click="optionEvent(3)">機車原融申請表-轉和潤申請書</v-btn>
          </v-flex>
        </v-layout>
        <br>
        <v-layout xs12 v-if="(item.category === 0 || item.category === 3) && isAdmin">
          <v-flex>
            <v-btn class="primary" dark text  @click="optionEvent(4)">機車原融申請表-和潤申請書套印</v-btn>
          </v-flex>
        </v-layout>
        <br>
        <v-layout xs12 v-if="(item.category === 2)">
          <v-flex>
            <v-btn class="primary" dark text  @click="optionEvent(6)">CA申請表-列印</v-btn>
          </v-flex>
        </v-layout>
        <br>
        <v-layout xs12 v-if="(item.category === 2)">
          <v-flex>
            <v-btn class="primary" dark text  @click="optionEvent(5)">CA申請表-套印</v-btn>
          </v-flex>
        </v-layout>
        <br>
        <v-layout xs12 v-if="(item.category === 5)">
          <v-flex>
            <v-btn class="primary" dark text  @click="optionEvent(7)">創鉅申請書-列印</v-btn>
          </v-flex>
        </v-layout>
        <br>
        <v-layout xs12 v-if="(item.category === 5)">
          <v-flex>
            <v-btn class="primary" dark text  @click="optionEvent(8)">創鉅申請書-套印</v-btn>
          </v-flex>
        </v-layout>
        <br>
        <v-layout xs12 v-if="(item.category === 6)">
          <v-flex>
            <v-btn class="primary" dark text  @click="optionEvent(10)">合迪申請書-列印</v-btn>
          </v-flex>
        </v-layout>
        <br>
        <v-layout xs12 v-if="(item.category === 6) && isAdmin">
          <v-flex>
            <v-btn class="primary" dark text  @click="optionEvent(11)">合迪申請書-套印</v-btn>
          </v-flex>
        </v-layout>
        <br>
        <v-layout xs12 v-if="(item.category === 6) && (isAdmin || isStaff)">
          <v-flex>
            <v-btn class="primary" dark text  @click="optionEvent(22)">中租合迪付款買賣契約-套印</v-btn>
          </v-flex>
        </v-layout>
        <br>
        <v-layout xs12 v-if="(item.category === 6) && (isAdmin || isStaff)">
          <v-flex>
            <v-btn class="primary" dark text  @click="optionEvent(23)">中租合迪動產抵押契約書-套印</v-btn>
          </v-flex>
        </v-layout>
        <br>
        <v-layout xs12 v-if="(item.category === 6) && (isAdmin || isStaff)">
          <v-flex>
            <v-btn class="primary" dark text  @click="optionEvent(24)">中租合迪動產抵押設定登記申請書-A3套印</v-btn>
          </v-flex>
        </v-layout>
        <br>
        <v-layout xs12 v-if="(item.category === 6) && (isAdmin || isStaff)">
          <v-flex>
            <v-btn class="primary" dark text  @click="optionEvent(25)">中租合迪買賣契約-套印</v-btn>
          </v-flex>
        </v-layout>
        <br>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary" dark text @click="confirmEvent">關閉</v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>

</template>

<script>
import { mapGetters } from 'vuex';
import common from '@/mixins/common.vue';

export default {
  name: 'PrintDialog',
  props: {
    visible: Boolean,
    item: Object,
  },
  mixins:[common],
  data() {
    return {
      loading: false,
      valid: true,
      dialog: false,
      isVisible:false,
    };
  },
  watch:{
    visible(value){
      this.isVisible = value;
    },
    isVisible(value){
      console.log(`show PrintDialog item  === ${value} / ${JSON.stringify(this.item)}`);
      if(!value)
      {
        this.$emit('closeEvent');
      }
    }
  },
  computed:{
    ...mapGetters(['getUserInfo',]),
  },
  methods: {
    optionEvent(eventKey){
      this.$emit('showEvent', eventKey);
    },
    confirmEvent(){
      this.$emit('confirmEvent', true);
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/PrintDialog.vue